/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Dispatch, SetStateAction } from "react";
import {
  CostSettings,
  CostSettingsInput,
  Maybe,
  EnvCostShare,
} from "~/generated/graphql";
import {
  ApplicationOption,
  EnvironmentOption,
} from "~/views/estate/components/types";

export enum CostMappingAlgorithm {
  Equal = "EQUAL",
  Manual = "MANUAL",
  Proportional = "PROPORTIONAL",
}

export type CostSplittingEnvSelectorProps = {
  algorithm: CostMappingAlgorithm | undefined;
  isOpen: boolean;
  isOpenAllocatedMethodSidebar: boolean;
  applications?: ApplicationOption[];
  onChange?: () => void;
  onClose: () => void;
  value: CostSettings;
  ruleId?: string;
  saveDataOnly?: boolean;
  envCostShares?: EnvCostShare[];
  setEnvCostShares?: (envCosts: EnvCostShare[]) => void;
};

export type EnvSelectorRowProps = {
  name: string;
  envs: EnvCostShare[];
  environments: Maybe<EnvironmentOption>[] | null | undefined;
  setEnvs: Dispatch<SetStateAction<EnvCostShare[]>>;
  algorithm: CostMappingAlgorithm | undefined;
  applications: ApplicationOption[];
  nid: string;
};

export type EnvEditState = {
  id: string;
  algorithm: CostMappingAlgorithm | undefined;
  settings?: Maybe<CostSettingsInput>;
};
